import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';

export interface DownloadTransactionDocumentRequest {
    engagementId: number;
    versionId: number;
}

export const DownloadTransactionDocument = createAsyncThunk(
    'transactionDocuments/downloadTransactionDocument',
    async (params: DownloadTransactionDocumentRequest, dispatch: any) => {
        const axios = dispatch.getState().core.axios;

        try {
            const response = await axios.get(
                `/api/Marketplace/Engagements/${params.engagementId}/TransactionDocuments/Versions/${params.versionId}/File`,
                { responseType: 'blob' }
            );

            if (response.status !== 200) {
                throw new Error('Failed to download the document');
            }

            return response.data as Blob;
        } catch (error) {
            createNotification('Could not download the document.', 'error');
            throw error;
        }
    }
);
